export const canRefresh = () => !document.hidden && navigator.onLine !== false;

export default function createVisibilityPoller(callback, interval = 30000, { immediate = false } = {}) {
  let timer = null;
  let controller = null;
  let stopped = false;
  let running = false;
  let available = canRefresh();
  let resumeRequested = false;
  const clearTimer = () => { clearTimeout(timer); timer = null; };
  const schedule = () => {
    clearTimer();
    if (!stopped && canRefresh()) timer = setTimeout(tick, interval);
  };
  const tick = async () => {
    if (stopped || !canRefresh()) return;
    if (running) { resumeRequested = true; return; }
    clearTimer();
    running = true;
    resumeRequested = false;
    controller = new AbortController();
    try { await callback(controller.signal); }
    catch (error) { /* Callers own error reporting. */ }
    finally {
      running = false;
      controller = null;
      if (!stopped && resumeRequested && canRefresh()) tick();
      else schedule();
    }
  };
  const onAvailabilityChange = () => {
    const next = canRefresh();
    if (next === available) return;
    available = next;
    clearTimer();
    if (!next) {
      resumeRequested = false;
      if (controller) controller.abort();
    } else tick();
  };
  document.addEventListener('visibilitychange', onAvailabilityChange);
  window.addEventListener('online', onAvailabilityChange);
  window.addEventListener('offline', onAvailabilityChange);
  if (immediate && available) tick();
  else schedule();
  return () => {
    stopped = true;
    clearTimer();
    if (controller) controller.abort();
    document.removeEventListener('visibilitychange', onAvailabilityChange);
    window.removeEventListener('online', onAvailabilityChange);
    window.removeEventListener('offline', onAvailabilityChange);
  };
}
